import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css'; 
import 'select2-theme-bootstrap4/dist/select2-bootstrap.css'; 

let stationReorderInProgress = false
window.stationReorderInProgress = false

function setSelectValueSilently(select, value) {
  const normalizedValue = value || ''
  if (select.value === normalizedValue) return

  const onchange = select.getAttribute('onchange')
  select.removeAttribute('onchange')

  const $select = $(select)
  const hadSelect2 = !!$select.data('select2')
  if (hadSelect2) $select.select2('destroy')

  select.value = normalizedValue
  $select.val(normalizedValue)
  if (hadSelect2) $select.select2()

  if (onchange) select.setAttribute('onchange', onchange)
}

function captureSlotCandidates(container) {
  return [...container.querySelectorAll('.nested-fields')].map(row => {
    const select = row.querySelector('select[name*="candidate_uic"]')
    return select ? select.value : ''
  })
}

function restoreSlotCandidates(container, slotCandidates) {
  const rows = [...container.querySelectorAll('.nested-fields')]
  rows.forEach((row, index) => {
    const select = row.querySelector('select[name*="candidate_uic"]')
    if (!select || slotCandidates[index] === undefined) return

    setSelectValueSilently(select, slotCandidates[index])
  })
}

function restoreStationOrder(container, orderedIds) {
  const rowsById = {}
  container.querySelectorAll('.nested-fields').forEach(row => {
    rowsById[row.dataset.stationId] = row
  })
  orderedIds.forEach(id => container.appendChild(rowsById[id]))
}

function updateStationFlowLoopArrow() {
  const diagram = document.getElementById('station-flow-diagram')
  if (!diagram) return

  const wrapper = diagram.querySelector('.station-flow-wrapper')
  const path = diagram.querySelector('.station-flow-loop-path')
  const boxes = diagram.querySelectorAll('.station-flow-box')
  if (!wrapper || !path || boxes.length < 2) {
    if (path) path.setAttribute('d', '')
    return
  }

  const wrapperRect = wrapper.getBoundingClientRect()
  const firstRect = boxes[0].getBoundingClientRect()
  const lastRect = boxes[boxes.length - 1].getBoundingClientRect()

  const firstX = firstRect.left + firstRect.width / 2 - wrapperRect.left
  const lastX = lastRect.left + lastRect.width / 2 - wrapperRect.left
  const startY = firstRect.bottom - wrapperRect.top + 6
  const loopY = startY + 30

  path.setAttribute(
    'd',
    `M ${lastX} ${startY} L ${lastX} ${loopY} L ${firstX} ${loopY} L ${firstX} ${startY}`
  )
}

function updateStationFlowDiagram() {
  const itemsContainer = document.getElementById('station-flow-items')
  const rowsContainer = document.getElementById('station-rows')
  if (!itemsContainer || !rowsContainer) return

  const rows = [...rowsContainer.querySelectorAll('.nested-fields')]
  itemsContainer.innerHTML = ''

  rows.forEach((row, index) => {
    const label = row.dataset.flowLabel || ''
    const isRest = row.dataset.isRest === 'true'

    const box = document.createElement('div')
    box.className = `station-flow-box ${isRest ? 'station-flow-box--rest' : 'station-flow-box--exam'}`
    box.draggable = true
    box.dataset.stationId = row.dataset.stationId
    box.title = 'Seret untuk mengubah urutan'
    box.innerHTML = `<div class="station-flow-num">${index + 1}</div><div class="station-flow-label">${label}</div>`
    itemsContainer.appendChild(box)

    if (index < rows.length - 1) {
      const arrow = document.createElement('span')
      arrow.className = 'station-flow-h-arrow'
      arrow.setAttribute('aria-hidden', 'true')
      arrow.innerHTML = '<i class="fas fa-long-arrow-alt-right"></i>'
      itemsContainer.appendChild(arrow)
    }
  })

  requestAnimationFrame(updateStationFlowLoopArrow)
}

function captureStationOrder(container) {
  return [...container.querySelectorAll('.nested-fields')].map(row => row.dataset.stationId)
}

function getAffectedStationIds(previousIds, currentIds) {
  const affected = new Set()
  const length = Math.max(previousIds.length, currentIds.length)

  for (let index = 0; index < length; index += 1) {
    if (previousIds[index] !== currentIds[index]) {
      if (previousIds[index]) affected.add(previousIds[index])
      if (currentIds[index]) affected.add(currentIds[index])
    }
  }

  return [...affected]
}

function flashStationHighlights(stationIds) {
  stationIds.forEach(stationId => {
    const row = document.querySelector(`#station-rows .nested-fields[data-station-id="${stationId}"]`)
    const box = document.querySelector(`#station-flow-diagram .station-flow-box[data-station-id="${stationId}"]`)

    ;[row, box].forEach(element => {
      if (!element) return

      element.classList.remove('station-highlight-flash')
      void element.offsetWidth
      element.classList.add('station-highlight-flash')
      element.addEventListener('animationend', () => {
        element.classList.remove('station-highlight-flash')
      }, { once: true })
    })
  })
}

function updateStationNumberDisplays(container) {
  container.querySelectorAll('.nested-fields').forEach((row, index) => {
    const display = row.querySelector('.station-number-display')
    if (display) display.textContent = index + 1
  })
}

function updateStationMoveButtons(container) {
  const rows = [...container.querySelectorAll('.nested-fields')]
  rows.forEach((row, index) => {
    const upBtn = row.querySelector('.station-move-up')
    const downBtn = row.querySelector('.station-move-down')
    if (upBtn) upBtn.disabled = index === 0
    if (downBtn) downBtn.disabled = index === rows.length - 1
  })
}

function applyStationOrderFromRows(container, reorderState) {
  if (!reorderState) return

  const { previousIds } = reorderState
  const affectedIds = getAffectedStationIds(previousIds, captureStationOrder(container))

  updateStationNumberDisplays(container)
  updateStationMoveButtons(container)
  updateStationFlowDiagram()
  submitStationReorder(container, reorderState)

  requestAnimationFrame(() => flashStationHighlights(affectedIds))
}

function reorderStationRows(container, draggedRow, targetRow) {
  if (!draggedRow || !targetRow || draggedRow === targetRow) return null

  const previousIds = captureStationOrder(container)
  const slotCandidates = captureSlotCandidates(container)
  const rows = [...container.querySelectorAll('.nested-fields')]
  const draggedIndex = rows.indexOf(draggedRow)
  const targetIndex = rows.indexOf(targetRow)

  if (draggedIndex < targetIndex) {
    targetRow.after(draggedRow)
  } else {
    targetRow.before(draggedRow)
  }

  return { previousIds, slotCandidates }
}

function reorderStationById(container, draggedStationId, targetStationId) {
  const draggedRow = container.querySelector(`.nested-fields[data-station-id="${draggedStationId}"]`)
  const targetRow = container.querySelector(`.nested-fields[data-station-id="${targetStationId}"]`)
  const reorderState = reorderStationRows(container, draggedRow, targetRow)
  if (!reorderState) return

  applyStationOrderFromRows(container, reorderState)
}

function moveStationRow(container, row, direction) {
  const rows = [...container.querySelectorAll('.nested-fields')]
  const index = rows.indexOf(row)
  const targetIndex = index + direction
  if (targetIndex < 0 || targetIndex >= rows.length) return

  const reorderState = reorderStationRows(container, row, rows[targetIndex])
  if (!reorderState) return

  applyStationOrderFromRows(container, reorderState)
}

function submitStationReorder(container, reorderState) {
  const reorderUrl = container.dataset.reorderUrl
  if (!reorderUrl) return

  const stationIds = [...container.querySelectorAll('.nested-fields')].map(row => row.dataset.stationId)
  stationReorderInProgress = true
  window.stationReorderInProgress = true

  $.ajax({
    url: reorderUrl,
    method: 'PATCH',
    dataType: 'script',
    data: { station_ids: stationIds },
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'text/javascript'
    }
  }).fail(() => {
    restoreStationOrder(container, reorderState.previousIds)
    restoreSlotCandidates(container, reorderState.slotCandidates)
    updateStationNumberDisplays(container)
    updateStationMoveButtons(container)
    updateStationFlowDiagram()
    alert('Gagal menyimpan urutan station. Silakan coba lagi.')
  }).always(() => {
    stationReorderInProgress = false
    window.stationReorderInProgress = false
  })
}

function initStationFlowSortable() {
  const diagram = document.getElementById('station-flow-diagram')
  const rowsContainer = document.getElementById('station-rows')
  if (!diagram || !rowsContainer || diagram.dataset.flowSortableInitialized) return
  diagram.dataset.flowSortableInitialized = 'true'

  let draggedStationId = null

  diagram.addEventListener('dragstart', (event) => {
    const box = event.target.closest('.station-flow-box')
    if (!box) return

    draggedStationId = box.dataset.stationId
    box.classList.add('station-flow-box--dragging')
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/plain', draggedStationId)
  })

  diagram.addEventListener('dragend', (event) => {
    const box = event.target.closest('.station-flow-box')
    if (box) box.classList.remove('station-flow-box--dragging')
    diagram.querySelectorAll('.station-flow-box--drag-over').forEach(el => {
      el.classList.remove('station-flow-box--drag-over')
    })
    draggedStationId = null
  })

  diagram.addEventListener('dragover', (event) => {
    const box = event.target.closest('.station-flow-box')
    if (!box || box.dataset.stationId === draggedStationId) return

    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'
    diagram.querySelectorAll('.station-flow-box--drag-over').forEach(el => {
      el.classList.remove('station-flow-box--drag-over')
    })
    box.classList.add('station-flow-box--drag-over')
  })

  diagram.addEventListener('dragleave', (event) => {
    const box = event.target.closest('.station-flow-box')
    if (box) box.classList.remove('station-flow-box--drag-over')
  })

  diagram.addEventListener('drop', (event) => {
    const box = event.target.closest('.station-flow-box')
    if (!box || !draggedStationId) return

    event.preventDefault()
    event.stopPropagation()
    box.classList.remove('station-flow-box--drag-over')
    if (box.dataset.stationId === draggedStationId) return

    reorderStationById(rowsContainer, draggedStationId, box.dataset.stationId)
  })
}

function initStationRowSortable(container) {
  if (!container || container.dataset.sortableInitialized) return
  container.dataset.sortableInitialized = 'true'

  let draggedRow = null

  const rows = () => [...container.querySelectorAll('.nested-fields')]

  container.addEventListener('click', (event) => {
    const upBtn = event.target.closest('.station-move-up')
    const downBtn = event.target.closest('.station-move-down')
    if (!upBtn && !downBtn) return

    event.preventDefault()
    const row = event.target.closest('.nested-fields')
    if (!row) return

    if (upBtn) moveStationRow(container, row, -1)
    if (downBtn) moveStationRow(container, row, 1)
  })

  rows().forEach(row => {
    const handle = row.querySelector('.station-drag-handle')
    if (!handle) return

    row.draggable = false

    handle.addEventListener('mousedown', () => {
      row.draggable = true
    })

    row.addEventListener('dragstart', (event) => {
      if (!row.draggable) {
        event.preventDefault()
        return
      }
      draggedRow = row
      row.classList.add('station-row-dragging')
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/plain', row.dataset.stationId)
    })

    row.addEventListener('dragend', () => {
      row.classList.remove('station-row-dragging')
      row.draggable = false
      draggedRow = null
      rows().forEach(r => r.classList.remove('station-row-drag-over'))
    })

    row.addEventListener('dragover', (event) => {
      event.preventDefault()
      event.dataTransfer.dropEffect = 'move'
      if (draggedRow && row !== draggedRow) {
        row.classList.add('station-row-drag-over')
      }
    })

    row.addEventListener('dragleave', () => {
      row.classList.remove('station-row-drag-over')
    })

    row.addEventListener('drop', (event) => {
      event.preventDefault()
      event.stopPropagation()
      row.classList.remove('station-row-drag-over')
      if (!draggedRow || draggedRow === row) return

      const reorderState = reorderStationRows(container, draggedRow, row)
      if (!reorderState) return

      applyStationOrderFromRows(container, reorderState)
    })
  })

  updateStationMoveButtons(container)
}

function initStationFormSubmitGuard() {
  const rowsContainer = document.getElementById('station-rows')
  if (!rowsContainer) return

  const form = rowsContainer.closest('form')
  if (!form || form.dataset.reorderGuardInitialized) return
  form.dataset.reorderGuardInitialized = 'true'

  form.addEventListener('submit', (event) => {
    if (stationReorderInProgress || window.stationReorderInProgress) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }, true)
}

document.addEventListener('turbolinks:load', () => {
  $('.select2').select2()
  initStationFormSubmitGuard()
  initStationFlowSortable()
  initStationRowSortable(document.getElementById('station-rows'))
  updateStationFlowDiagram()
  updateStationFlowLoopArrow()
})

window.addEventListener('resize', () => {
  updateStationFlowLoopArrow()
})
